import useResponsive from "src/hooks/useResponsive";
import { ConnectedEntity } from "src/types/apps";

import EntityItemBtn from "./EntityItemBtn";
import EntityItemMobile from "./EntityItemMobile";

// ----------------------------------------------------------------------

type Props = {
	item: ConnectedEntity;
};

export const EntityItem = ({ item }: Props) => {
	const isMobile = useResponsive("down", "sm");

	return isMobile ? (
		<EntityItemMobile key={item.id} item={item} />
	) : (
		<EntityItemBtn key={item.id} item={item} />
	);
};

export default EntityItem;
